export default "<p>delink works!</p>\n";